import React from 'react';

const StepBox = ({ icon, title, description }) => {
  return (
    <div style={styles.textWrapper}>
      <div style={styles.highlight} />
      <div style={styles.stepBox}>
        <img src={icon} alt="Step icon" style={styles.icon} />
        <h4 style={styles.title}>{title}</h4>
        <p style={styles.description}>{description}</p>
      </div>
    </div>
  );
};

export default StepBox;

const styles = {
  textWrapper: {
    position: 'relative',
    width: 250,
    height: 400,
    marginRight: 70,
  },
  highlight: {
    position: 'absolute',
    top: 20,
    left: 20,
    width: 300,
    height: 412,
    backgroundColor: '#0f0f0f',
    opacity: 1,
    border: '1px solid yellow',
    borderRadius: 12,
    zIndex: 1,
 
  },
  stepBox: {
    position: 'relative',
    width:300,
    height: 412,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 12,
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    backdropFilter: 'blur(6px)',
    zIndex: 2,
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  icon: {
    width: 80,
    height: 80,
    marginBottom: 20,
    zIndex: 2,
  },
  title: {
    fontSize: '24px',
    lineHeight:'32px',
    fontWeight: 700,
    color: '#d3e205',
    marginBottom: 30,
    zIndex: 2,
  },
  description: {
    color: 'rgba(255, 255, 255, 0.87)',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '28px',
    textAlign: 'left',
    zIndex: 2,
  },
};
